import React from 'react';
import { useQuery } from '@tanstack/react-query';
import { Link, useParams } from 'react-router-dom';
import { getTicket } from '../../services/ticket_api';
import useUserStore from '../../store/UserStore';
import { t } from '../Language/Translator';
import Loader from '../commonForm/Loader';
import { format } from 'date-fns';
import { attachmentURL } from '../../constant/const';

const ViewTicket = () => {
    const { id } = useParams();

    const user_data = useUserStore((state) => state.user);
    const token = user_data;
    const userInfo = useUserStore((state) => state.userInfo);
    const isNotCustomer = !['customer', 'secondary_customer'].includes(userInfo?.user_type);

    const { data: ticket, isLoading, error } = useQuery({ queryKey: ['ticket', id], queryFn: () => getTicket(token, id), enabled: id ? true : false });
    return (
        <>
            <div className="top_section">
                <div className="pagesNamelink">
                    <nav aria-label="breadcrumb">
                        <ol className="breadcrumb">
                            <li className="breadcrumb-item"><Link to="/dashboard">{t("admindashboard.dashboard")}</Link></li>
                            <li className="breadcrumb-item"><Link to="/tickets">{t("tickets.ticket")}</Link></li>
                            <li className="breadcrumb-item text-white">{t("viewticket.viewticket")}</li>
                        </ol>
                    </nav>
                    <h4 className="text-white">{t("viewticket.viewticket")}</h4>
                </div>
            </div>
            <div className="mainSection">
                <div className="viewTicket row g-3">
                    {isLoading && <Loader />}

                    {ticket &&
                        <>
                            <div className="col-xxl-3 col-xl-3 col-lg-4 col-md-6 col-sm-12">
                                <h6>{t("viewticket.alert")}</h6>
                                <p>{ticket.data?.alert}</p>
                            </div>
                            <div className="col-xxl-3 col-xl-3 col-lg-4 col-md-6 col-sm-12">
                                <h6>{t("viewticket.alerttype")}</h6>
                                <p>{ticket.data?.alert_type}</p>
                            </div>
                            <div className="col-xxl-3 col-xl-3 col-lg-4 col-md-6 col-sm-12">
                                <h6>{t("viewticket.severity")}</h6>
                                <p className="statusClosed">{ticket.data?.severity}</p>
                            </div>
                            <div className="col-xxl-3 col-xl-3 col-lg-4 col-md-6 col-sm-12">
                                <h6>{t("viewticket.customer")}</h6>
                                <p>{ticket.data.customer_first_name + ' ' + ticket.data?.customer_last_name}</p>
                            </div>
                            <div className="col-xxl-3 col-xl-3 col-lg-4 col-md-6 col-sm-12">
                                <h6>{t("viewticket.assignto")}</h6>
                                <p>{ticket.data.analyst_first_name + ' ' + ticket.data?.analyst_last_name}</p>
                            </div>
                            <div className="col-xxl-3 col-xl-3 col-lg-4 col-md-6 col-sm-12">
                                <h6>{t("viewticket.sourceip")}</h6>
                                <p style={{wordBreak: 'break-all',}}>{ticket.data.source_ip} | {ticket.data?.src_port}</p>
                            </div>
                            <div className="col-xxl-3 col-xl-3 col-lg-4 col-md-6 col-sm-12">
                                <h6>{t("viewticket.destinationip")}</h6>
                                <p style={{wordBreak: 'break-all',}}>{ticket.data.destination_ip} | {ticket.data?.dst_port}</p>
                            </div>
                            <div className="col-xxl-3 col-xl-3 col-lg-4 col-md-6 col-sm-12">
                                <h6>{t("viewticket.timestamp")} </h6>
                                <p>{format(ticket.data?.timestamp, "MM/dd/yyyy hh:mm a")}</p>
                            </div>
                            <div className="col-xxl-3 col-xl-3 col-lg-4 col-md-6 col-sm-12">
                                <h6>{t("viewticket.status")}</h6>
                                <p className="statusProgress">{ticket.data?.status}</p>
                            </div>
                            <div className="col-xxl-3 col-xl-3 col-lg-4 col-md-6 col-sm-12">
                                <h6>{t("viewticket.processnamefilename")}</h6>
                                <p className="statusProgress">{ticket.data?.fileName}</p>
                            </div>
                            <div className="col-xxl-3 col-xl-3 col-lg-4 col-md-6 col-sm-12">
                                <h6>{t("viewticket.domain")}</h6>
                                <p className="statusProgress">{ticket.data?.domain}</p>
                            </div>
                            <div className="col-xxl-3 col-xl-3 col-lg-4 col-md-6 col-sm-12">
                                <h6>{t("viewticket.attachments")}</h6>
                                <div className='flex flex-wrap items-center gap-x-4'>
                                    {ticket.data.attachments.length > 0 ? (
                                        ticket.data.attachments.map((file, i) => (
                                            <span className='UploadedFile m-0' key={i}>
                                                {['super_admin', 'admin', 'analyst', 'customer', 'secondary_customer'].includes(userInfo?.user_type) ? (
                                                    <a
                                                        href={`${attachmentURL}/uploads/${file.filename}`}
                                                        target='_blank'
                                                        rel="noopener noreferrer"
                                                        className="text-blue-600 underline"
                                                    >
                                                        {file?.originalname}
                                                    </a>
                                                ) : (
                                                    <span className="text-gray-500">{file?.originalname}</span> // Non-clickable for others
                                                )}
                                            </span>
                                        ))
                                    ) : (
                                        <p>No attachments</p>
                                    )}
                                </div>
                            </div>
                            <div className="col-xxl-12 col-xl-12 col-lg-12 col-md-12 col-sm-12">
                                <h6>{t("viewticket.virustotallink")}</h6>
                                <a href={ticket.data.virus_total_link} target='_blank' className="linkFile">
                                    {ticket.data?.virus_total_link}
                                </a>
                            </div>
                            <div className="col-xxl-12 col-xl-12 col-lg-12 col-md-12 col-sm-12">
                                <h6>{t("viewticket.abuseddblink")}</h6>
                                <a href={ticket.data.abuse_db_link} target='_blank' className="linkFile">
                                    {ticket.data?.abuse_db_link}
                                </a>
                            </div>
                            <div className="col-xxl-12 col-xl-12 col-lg-12 col-md-12 col-sm-12">
                                <h6>{t("viewticket.filehash")}</h6>
                                <p>
                                    {ticket.data?.fileHash}
                                </p>
                            </div>
                            <div className="col-xxl-12 col-xl-12 col-lg-12 col-md-12 col-sm-12">
                                <h6>Created By</h6>
                                <p>
                                    {ticket.data?.created_by}
                                </p>
                            </div>
                            <div className="col-xxl-12 col-xl-12 col-lg-12 col-md-12 col-sm-12">
                                <h6>Summary</h6>
                                <p>{ticket.data?.summary}</p>
                            </div>
                            <div className="col-xxl-12 col-xl-12 col-lg-12 col-md-12 col-sm-12">
                                <h6>{t("viewticket.customersummary")}</h6>
                                <p>{ticket.data?.customer_summary}</p>
                            </div>
                        </>
                    }
                    {error && <p>{t("viewticket.somethingwentwrong")}</p>}
                </div>
            </div>
        </>
    );
}

export default ViewTicket;